export class ProtocoloAtendimento {
    //Id: number; /* "IdProtocoloAtendimento" Nao utilizado no mockup, gravando ProtocoloAtendimento dentro de Protocolo */
    //IdProtocolo: number; /* Nao utilizado no mockup, gravando ProtocoloAtendimento dentro de Protocolo */
    IdPessoa: number;
    IdProtocoloAtendimentoCanal: number;
    IdProtocoloAtendimentoTipo: number;
    DtHrAtendimento: Date;
    DescricaoAtendimento: string;
    SenhaAtendimento: string;
}

export class ProtocoloServico {
    //Id: number; /* "IdProtocoloServico" Nao utilizado no mockup, gravando ProtocoloServico dentro de Protocolo */
    //IDProtocolo: number;  /* Nao utilizado no mockup, gravando ProtocoloServico dentro de Protocolo */
    IdServico: number;
}

export class ProtocoloEvento {
    //Id: number; /* "IdProtocoloEvento" Nao utilizado no mockup, gravando ProtocoloEvento dentro de Protocolo */
    IdEvento: number;
    //IdProtocolo: number; /* Nao utilizado no mockup, gravando ProtocoloEvento dentro de Protocolo */
    DtHrEvento: Date;
    ObservacaoEvento: string;
}

export class ProtocoloEstados {
    //Id: number; /* "IdProtocoloEstados" Nao utilizado no mockup, gravando ProtocoloEstados dentro de Protocolo */
    //IdProtocolo: number; /* Nao utilizado no mockup, gravando ProtocoloEstados dentro de Protocolo */
    IdEstadosAndamento: number;
    DtHrProtocoloEstado: Date;
}

export class ProtocoloAgendamento {
    //Id: number; /* "IdProtocoloAgendamento" Nao utilizado no mockup, gravando ProtocoloAgendamento dentro de Protocolo */
    //IdProtocolo: number; /* Nao utilizado no mockup, gravando ProtocoloAgendamento dentro de Protocolo */
    DtHrCadastro: Date;
    DtHrAgendamento: Date;
    DescricaoAgendamento: string;
}

export class Protocolo {
    Id: number;
    IdContrato: number;
    IdProtocoloMotivo: number;

    ProtocoloAtendimento: ProtocoloAtendimento[];
    ProtocoloServico: ProtocoloServico[];
    ProtocoloEvento: ProtocoloEvento[];
    ProtocoloEstados: ProtocoloEstados[];
    ProtocoloAgendamento: ProtocoloAgendamento[];

    constructor() {
        this.ProtocoloAtendimento = [];
        this.ProtocoloServico = [];
        this.ProtocoloEvento = [];
        this.ProtocoloEstados = [];
        this.ProtocoloAgendamento = [];
    }
}



// WEBPACK FOOTER //
// ./src/app/protocolo/protocolo.model.ts